export default "__VITE_ASSET__BdQU5Ei0__"